define('controllers/callcenter/email',['require','nicEditlatest'],function (require) {
    require('nicEditlatest');
    return function () {
        var emaildata = window.ServerData.feData.EmailData;
        var templates = emaildata.templates;
        var globalReplaces = emaildata.globalreplaces;

        var txtEmailTemplateID = "txtEmailTemplate",
            //emailTemplate = new nicEditor({ fullPanel: true, maxHeight: 400 }).panelInstance(txtEmailTemplateID, { hasPanel: true }),
            txtName = $("#txtName"),
            txtDescription = $("#txtDescription"),
            txtSubject = $("#txtSubject"),
            txtEmailTemplate = $("#txtEmailTemplate"),
            ddlEmailTemplate = $("#ddlEmailTemplate"),
            chkRequired = $("#chkRequired"),
            Msg = $("#Msg, #Msg2");

        bindTemplates();
        function bindTemplates() {
            var options = [];
            for (var i = 0, templatesLength = templates.length; i < templatesLength; i++) {
                var template = templates[i];
                options.push("<option value=\"{0}\">{1}</option>".format(template.Id, template.NameTemplate));
            }
            ddlEmailTemplate.html(options.join(""));
        }

        //bind global replaces...
        var globalReplacesRecords = [];
        for (var i = globalReplaces.length - 1; i >= 0; i--) {
            var gReplace = globalReplaces[i];
            globalReplacesRecords.push('<strong>{0} : </strong>{1}<br />'.format(gReplace.Key, gReplace.Value));
        }
        $("#globalReplaces").html(globalReplacesRecords.join(""));

        $("#btnSave, #btnInactivate").on("click", function () {
            var $this = $(this),
            //template = emailTemplate.instanceById(txtEmailTemplateID),
                inactivating = $this.prop('id') == "btnInactivate",
                templateId = ddlEmailTemplate.val(),
                data = {
                    method: "save",
                    EMailID: templateId,
                    Name: txtName.val(),
                    Description: txtDescription.val(),
                    Subject: txtSubject.val(),
                    NewBody: Utilities.htmlEncode(txtEmailTemplate.val()), //template.getContent()),
                    Required: chkRequired.is(":checked")
                },
                errors = validate(data);

            if (errors.length == 0) {
                if (inactivating) {
                    data.Inactive = new Date();
                }

                $this.prop('disabled', true);
                Msg.hide();

                $.ajax({
                    url: 'EmailAJAX.aspx',
                    type: 'POST',
                    data: data,
                    cache: false,
                    success: function (response) {
                        var responseObject = JSON.parse(response);
                        setSuccess(inactivating ? "Inactivated and Saved Successfully" : "Saved Successfully");

                        //set content
                        txtEmailTemplate.val(responseObject.body);  //template.setContent(responseObject.body);

                        //rebind ddl
                        templates = responseObject.templates;
                        bindTemplates();
                        ddlEmailTemplate.val(responseObject.templateID);
                    },
                    error: function () {
                        setError("There was an error saving.");
                    },
                    complete: function () {
                        $this.prop('disabled', false);
                    }
                });
            } else {
                setError(errors.join("<br />"));
            }
        });

        function validate(email) {
            var errors = [],
                addingNew = ddlEmailTemplate.val() == 0;

            if (email.Name == "" && addingNew) errors.push("-Please enter a name.");
            if (email.Subject == "") errors.push("-Please enter a subject.");
            if (email.NewBody == "") errors.push("-Please enter a body.");

            return errors;
        }

        ddlEmailTemplate.on("change", function () {
            var templateId = ddlEmailTemplate.val(),
                loading = ddlEmailTemplate.next(),
                addingNew = ddlEmailTemplate.val() == 0;

            if (!addingNew) {
                loading.show();
                Msg.hide();

                $.ajax({
                    url: 'EmailAJAX.aspx',
                    type: 'POST',
                    data: { method: "getTemplates", EMailID: templateId },
                    cache: false,
                    success: function (emailTemplateResponse) {
                        //CheckIfLoginPage(emailTemplateResponse);

                        var responseObject = JSON.parse(emailTemplateResponse);

                        txtName.val(Utilities.htmlDecode(responseObject.Name));
                        txtDescription.val(Utilities.htmlDecode(responseObject.Description));
                        txtSubject.val(Utilities.htmlDecode(responseObject.Subject));
                        txtEmailTemplate.val(responseObject.Body); //emailTemplate.instanceById(txtEmailTemplateID).setContent(responseObject.Body);
                        responseObject.Required ? chkRequired.prop('checked', true) : chkRequired.prop('checked', false);

                        addDynamicReplaceBoxes(responseObject.Body);
                    },
                    error: function () {
                    },
                    complete: function () {
                        loading.hide();
                    }
                });
            } else {
                //clear form
                txtName.val("");
                txtDescription.val("");
                txtSubject.val("");
                txtEmailTemplate.val(""); // emailTemplate.instanceById(txtEmailTemplateID).setContent("");
                $("#replaceInputs").html("");
            }
        });

        //test template
        function GetReplaces(content) {
            var replaces = content.match(/\{([^\;]*?)\}/g); //anything that's not a semi-colon in-between brackets -- don't want to pick up css blocks
            var finalReplaces = [];

            if (replaces != null) {
                //get uniques from replaces
                for (var i = replaces.length - 1; i >= 0; i--) {
                    var replace = replaces[i];
                    if ($.inArray(replace, finalReplaces) == -1) {
                        finalReplaces.push(replace);
                    }
                }
            }
            return finalReplaces;
        }

        $("#btnTest").on("click", function () {
            var email = $("#email").val().trim(),
                subject = $("#txtSubject").val(),
                message = txtEmailTemplate.val(), // emailTemplate.instanceById(txtEmailTemplateID).getContent(),
                $this = $(this);

            if (email != "") {
                //replace in message
                $("#replaceInputs input").each(function () {
                    var $this = $(this),
                    replaceWord = $this.prop('id').replace("replaceBox_", ""),
                    replaceValue = $this.val();

                    if (subject.includes(replaceWord)) subject = subject.replace(replaceWord, replaceValue);
                    message = message.replace(new RegExp(replaceWord, "g"), replaceValue);
                });

                //add in globals...
                for (var i = globalReplaces.length - 1; i >= 0; i--) {
                    var gReplace = globalReplaces[i];
                    message = message.replace(new RegExp(gReplace.Key, "g"), gReplace.Value);
                }

                Msg.hide();
                $this.prop('disabled', true);

                console.log(message);
                $.ajax({
                    url: 'EmailAJAX.aspx',
                    type: 'POST',
                    data: { method: "testTemplate", Email: email, Subject: subject, Body: Utilities.htmlEncode(message) },
                    cache: false,
                    success: function () {
                        setSuccess("Successfully Sent the test email");
                    },
                    error: function () {
                        setError("There was an error sending the test email.");
                    },
                    complete: function () {
                        $this.prop('disabled', false);
                    }
                });
            } else {
                setError("Please enter an email address.");
            }
        });

        $("#btnSendEmailCampaign").on("click", function (e) {
            e.preventDefault();
            var templateId = ddlEmailTemplate.val();
            if (templateId > 0) {
                window.location = "/Callcenter/Email/Campaign/?tid=" + templateId;
            } else {
                setError("Choose an email template to use.");
            }
        });

        function setError(message) {
            Msg.addClass("alert-error").removeClass("alert-info").html(message).show();
        }
        function setSuccess(message) {
            Msg.addClass("alert-info").removeClass("alert-error").html(message).show();
        }

        //            $("#txtUriEncode").on("change", function () {
        //                $("#encodedResult").text(encodeURIComponent($(this).val()));
        //            });

        function addDynamicReplaceBoxes(templateBody) {
            //add dynamic text boxes for each {ReplaceWord} <label for="{0}">{0}</label><br /><input type="text" name="{0}" /><br />
            var replaces = GetReplaces(templateBody);
            var replaceBoxes = [];
            var globalReplaceKeys = [];
            for (var i = globalReplaces.length - 1; i >= 0; i--) {
                var key = globalReplaces[i].Key;
                globalReplaceKeys.push(key);
            }
            for (var i = replaces.length - 1; i >= 0; i--) {
                var replace = replaces[i];
                if ($.inArray(replace, globalReplaceKeys) === -1) { //only add ones that aren't global
                    replaceBoxes.push('<label for="replaceBox_{0}">{0}</label><br /><input type="text" id="replaceBox_{0}" value="{0}" /><br />'.format(replace));
                }
            }
            $("#replaceInputs").html(replaceBoxes.join(""));
        }

        txtEmailTemplate.on('keyup', function () {
            addDynamicReplaceBoxes(txtEmailTemplate.val());
        });

        ddlEmailTemplate.focus();
    };
});

